import React from "react";
import IconCustom from "../../../../../../../Utils/IconCustom/IconCustom";

const IconComponent = ({component}) => {
    const {styles: sourceStyles, properties: {icon, iconType} = {}} = component;
    const styles = sourceStyles && sourceStyles.length ? sourceStyles[0] : {};
    return (
        <IconCustom
            iconType={iconType}
            style={{...styles}}>
            {icon}
        </IconCustom>
    )
};

export default IconComponent;